// extracted by mini-css-extract-plugin
export var center = "_1o-2";
export var clickableRow = "_1o-5";
export var expandedRow = "_1o-7";
export var hoverable = "_1o-4";
export var left = "_1o-1";
export var right = "_1o-3";
export var row = "_1o-0";
export var selectedRow = "_1o-6";
export var summaryRow = "_1o-8";